import { render, staticRenderFns } from "./SchemeTypePaymentAddEdit.vue?vue&type=template&id=6078d45a"
import script from "./SchemeTypePaymentAddEdit.vue?vue&type=script&lang=js"
export * from "./SchemeTypePaymentAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports